<template>
  <span>
    <div class="col-md-12">
      <div class="table-responsive">
        <table id="dataTableExample" class="table table-hover">
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Parameter Setup</th>
              <th>Parameter Setup Detail</th>
              <th>Reading</th>
              <th class="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <loading-table :isLoading="isLoading" cols="14"></loading-table>
            <tr v-if="form.parameter_monitoring_details.length == 0">
              <td colspan="14" class="text-center">No data Found</td>
            </tr>
            <tr
              v-for="(
                parameter_monitoring_detail, sr
              ) in form.parameter_monitoring_details"
              :key="`parameter_monitoring_detail${sr}`"
            >
              <td>{{ sr + 1 }}.</td>
              <td>
                <my-select
                  disableFormControl="true"
                  :selection.sync="
                    parameter_monitoring_detail.parameter_setup_id
                  "
                  :suggestions="parameter_setups"
                  placeholder="Select Parameter Setup"
                ></my-select>
              </td>
              <td>
                <my-select
                  disableFormControl="true"
                  :selection.sync="
                    parameter_monitoring_detail.parameter_setup_detail_id
                  "
                  :suggestions="parameter_setup_details"
                  placeholder="Select Parameter Setup Details
"
                ></my-select>
              </td>
              <td>
                <input
                  v-uppercase
                  type="text"
                  class="form-control"
                  placeholder="Reading"
                  v-model="parameter_monitoring_detail.reading"
                />
              </td>

              <td>
                <div class="text-center">
                  <button
                    class="btn btn-danger btn-sm"
                    @click="
                      deleteParameterMonitoringDetail(
                        parameter_monitoring_detail
                      )
                    "
                    v-if="!parameter_monitoring_detail.id"
                  >
                    Delete
                  </button>
                  <button
                    class="btn btn-danger btn-sm"
                    @click="
                      delete_parameter_monitoring_detail_data(
                        parameter_monitoring_detail.id
                      )
                    "
                    v-else
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
            <tr v-if="form.parameter_monitoring_details">
              <td
                colspan="14"
                align="center"
                @click="addEmptyParameterMonitoringDetails()"
                style="
                  background-color: #6571ff;
                  color: white;
                  border-radius: 10px;
                  box-shadow: none;
                "
              >
                Add New Row
              </td>
            </tr>
          </tbody>
        </table>
        <!-- /Table -->
      </div>
    </div>
  </span>
</template>

<script type="text/javascript">
import axios from "axios";
export default {
  name: "ParameterMonitoringDetailFormWidget",
  props: ["form"],
  data() {
    return {
      parameter_setups: [],
      parameter_setup_details: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("parameter_monitorings/masters");
      masters = masters.data;
      masters.parameter_setups.forEach((parameterSetup) => {
        this.parameter_setups.push({
          id: parameterSetup.id,
          name: parameterSetup.title,
        });
        parameterSetup.parameter_setup_details.forEach(
          (parameterSetupDetail) => {
            this.parameter_setup_details.push({
              id: parameterSetupDetail.id,
              name: parameterSetupDetail.parameter_name,
            });
          }
        );
      });
    },
    deleteParameterMonitoringDetail(detail) {
      this.form.parameter_monitoring_details =
        this.form.parameter_monitoring_details.filter((ar) => ar != detail);
    },
    addEmptyParameterMonitoringDetails() {
      this.form.parameter_monitoring_details.push({
        company_id: this.company.id,
        parameter_setup_id: "",
        parameter_setup_detail_id: "",
        reading: "",
      });
    },
    async delete_parameter_monitoring_detail_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(
            `delete?id=${id}&table_name=parameter_monitoring_details`
          );
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
